import React, { memo, type FC } from "react";
import { Select } from "../organisms/Select";
import { ButtonSecondary } from "../atoms/ButtonSecondary";
import { ButtonSoft } from "../atoms/ButtonSoft";
import { useTranslation } from "react-i18next";

export type NutritionMealTableAddProductProps = {
  hidden?: boolean;
  product: any;
  products?: Array<any>;
  onProductChange: (product: any) => void;
  onAccept: () => void;
  onCancel: () => void;
};

export const NutritionMealTableAddProduct: FC<NutritionMealTableAddProductProps> =
  memo(({ hidden, products, product, onProductChange, onCancel, onAccept }) => {
    console.debug("RenderingNutritioNmealTableAddProduct");
    const { t } = useTranslation();

    return (
      <tr className={hidden ? "hidden" : ""}>
        <td
          colSpan={2}
          className={"whitespace-nowrap px-3 py-5 text-sm text-gray-500 "}
        >
          <div className="w-[250px]">
            <Select
              name=""
              tittle=""
              selected={product}
              setSelected={onProductChange}
              options={products}
            />
          </div>
        </td>
        <td
          className={"whitespace-nowrap px-3 py-5 text-sm text-gray-500"}
        ></td>
        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-sm font-medium sm:pr-0 flex justify-end mr-5 gap-4">
          <ButtonSoft
            size="large"
            text={t("contexts.shared.add")}
            onClick={onAccept}
          />
          <ButtonSecondary
            size="large"
            text={t("contexts.shared.cancel")}
            onClick={onCancel}
          />
        </td>
      </tr>
    );
  });
